import { useMemo, useState } from 'react';

const useFilterRalated = (data = [], defaultStageFilter = []) => {
  const [stageFilter, setStageFilter] = useState(defaultStageFilter);
  const [warrantyFilter, setWarrantyFilter] = useState([]);

  const handleChangeStageFilter = (value) => {
    setStageFilter(value);
  };

  const handleChangeWarrantyFilter = (value) => {
    setWarrantyFilter(value);
  };

  const filteredDate = useMemo(() => {
    return data.filter((item) => {
      const matchStage =
        !stageFilter.length ||
        stageFilter.includes(String(item?.stageAddressLifeCycle?.id));
      const matchWarranty =
        !warrantyFilter.length ||
        warrantyFilter.includes(String(item?.garantyId));
      return matchStage && matchWarranty;
    });
  }, [data, stageFilter, warrantyFilter]);

  return {
    filteredDate,
    handleChangeStageFilter,
    handleChangeWarrantyFilter,
    selectedStage: stageFilter,
    selectedWar: warrantyFilter,
  };
};

export default useFilterRalated;
